import React from 'react';

export function buildFixedIncomeVariesNote(result, startYear, periodLength, label) {
  if (!result?.fixedIncomeVaries && !result?.endingBalanceUnachievable) return null;
  const start = Number(startYear) || 0;
  const years = Number(periodLength) || 0;
  return {
    label: label || null,
    minimum: Math.round(Number(result.minimumYearIncome ?? result.avgIncome) || 0),
    startYear: start,
    endYear: years > 0 ? start + years - 1 : start,
    endingBalanceMissed: !!result.endingBalanceUnachievable,
    requestedEndingBalance: Math.round(Number(result.requestedEndingBalance) || 0),
    finalBalance: Math.round(Number(result.finalBalance) || 0),
  };
}

export default function FixedIncomeVariesNote({ note, notes, onClose }) {
  const items = (Array.isArray(notes) ? notes : note ? [note] : []).filter(Boolean);
  if (!items.length) return null;
  const missedBalance = items.some((item) => item.endingBalanceMissed);

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/40 p-4" role="dialog" aria-modal="true" aria-labelledby="fixed-income-varies-title">
      <div className="max-w-lg w-full bg-white rounded-lg shadow-xl border border-amber-200 p-5">
        <h3 id="fixed-income-varies-title" className="text-lg font-bold text-gray-900">
          {missedBalance ? 'Requested final balance cannot be left' : 'Fixed income cannot be held flat'}
        </h3>
        <p className="mt-3 text-sm text-gray-700 leading-relaxed">
          {missedBalance
            ? 'This period cannot leave the requested final balance, even when super withdrawals stay at the compulsory minimum. The calculator does not ignore that target and spend the super down. Income still varies, because wages, the Age Pension and those minimums are not a flat line.'
            : 'This period cannot maintain one Fixed Sustainable Income. Wages, the Age Pension and compulsory super minimums make the payment vary from year to year.'}
        </p>
        {items.map((item, index) => (
          <p key={`${item.label || 'period'}-${item.startYear}-${index}`} className="mt-3 text-sm text-gray-700 leading-relaxed">
            {item.label ? `${item.label}: the figure shown, ` : 'The figure shown, '}
            ${Number(item.minimum || 0).toLocaleString()} a year for {item.startYear}–{item.endYear}, is the lowest year in the projection. It is not a guaranteed flat payment.
            {item.endingBalanceMissed
              ? ` The requested end balance was $${Number(item.requestedEndingBalance || 0).toLocaleString()}. What remains is $${Number(item.finalBalance || 0).toLocaleString()}.`
              : ''}
          </p>
        ))}
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-md"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
